import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import KeyCard from "./Card";
import './KeyFigures.css'

export default function KeyFigures(props) {
    const dashboard = useSelector((state) => state.dashboard);
    const [openKey, setOpenKey] = useState("");
    const [totalAttendees, setTotalAttendees] = useState('Loading...');
    const [recentAttendees, setRecentAttendees] = useState('Loading...');
    const [recentInspectionData, setRecentInspectionData] = useState([]);
    
    useEffect(() => {
        if (dashboard?.data?.inspections) {
            processInspectionData(dashboard.data.inspections);
        } else if (dashboard?.data?.listing?.inspections) {
            processInspectionData(dashboard.data.listing.inspections);
        } else {
            setTotalAttendees('Not available');
            setRecentAttendees('Not available');
        }
    }, [dashboard]);
    
    const processInspectionData = (inspectionsData) => {
        if (inspectionsData.total_attendees !== undefined) {
            setTotalAttendees(inspectionsData.total_attendees);
            
            if (inspectionsData.most_recent_total_attendees !== undefined) {
                setRecentAttendees(inspectionsData.most_recent_total_attendees);
            } else {
                setRecentAttendees('N/A');
            }
            
            if (inspectionsData.latest_10_inspections) {
                const dateData = inspectionsData.latest_10_inspections.map(insp => ({
                    date: insp.inspection_date,
                    start_time: insp.start_time,
                    attendees: insp.total_attendees
                }));
                setRecentInspectionData(dateData);
            } else if (inspectionsData.most_recent_inspections) {
                const dateData = inspectionsData.most_recent_inspections.map(insp => ({
                    date: insp.inspection_date,
                    start_time: insp.start_time,
                    attendees: insp.total_attendees
                }));
                setRecentInspectionData(dateData);
            }
        } 
        // Fallback handling for unexpected data structure
        else if (Array.isArray(inspectionsData)) {
            setTotalAttendees('Not available');
            setRecentAttendees('Not available');
        } else {
            setTotalAttendees('Not available');
            setRecentAttendees('Not available');
        }
    };
    
    const handleOpenKey = (value) => {
        if (value === openKey) {
            setOpenKey("");
        } else {
            setOpenKey(value);
        }
    }
    
    return (
        <div className="figures-base">
            <div className="figures-details">
                <KeyCard
                    key="visits"
                    opacity={''}
                    name={"Page Visits"}
                    value={dashboard?.data?.statistics?.total_property_page_views}
                    onClick={handleOpenKey}
                    open={openKey}/>
                <KeyCard
                    key="email"
                    opacity={'cc'}
                    name={"Email Enquiries"}
                    value={dashboard?.data?.statistics?.total_property_enquiries}
                    onClick={handleOpenKey}
                    open={openKey}/>
                <KeyCard
                    key="saves"
                    opacity={'99'}
                    name={"Saves"}
                    value={dashboard?.data?.statistics?.total_property_saves}
                    onClick={handleOpenKey}
                    open={openKey}/>
                <KeyCard
                    key="shares"
                    opacity={'66'}
                    name={"Shares"}
                    value={dashboard?.data?.statistics?.total_property_shares}
                    onClick={handleOpenKey}
                    open={openKey}/>
                <KeyCard
                    key="Total Attendees"
                    opacity={'33'} 
                    name={"Inspections - Total"}
                    value={totalAttendees}
                    recentValue={recentAttendees}
                    recentInspectionData={recentInspectionData}
                    onClick={handleOpenKey}
                    open={openKey}/>
            </div>
        </div>
    );
}